<template>
  <modal :value="value"
         max-width="500"
         content-class="marketing-sms-automation"
         :has-padding="false"
         @input="emitInput">
    <div class="close"
         @click="hideModal">&times;</div>

    <div class="marketing-sms-automation-body">
      <h1 class="marketing-sms-automation-body-title">{{ modalTitle }}</h1>

      <app-form @submit="onSubmit">
        <text-field v-model="internalTitle"
                    :disabled="!isEdit"
                    validate="required|min:2"
                    class="marketing-sms-automation-body-input"
                    :label="$t('message.sms.message.smsName')"
                    name="Nome do SMS"></text-field>

        <app-textarea v-model="content"
                      :validate="`required|min:2|max:${contentCounter}`"
                      :counter="contentCounter"
                      :help="$t('message.marketingGenerics.message.messageHint')"
                      class="marketing-sms-automation-body-text"
                      :label="$t('message.marketingGenerics.message.message')"
                      name="Mensagem"></app-textarea>

        <div class="marketing-sms-automation-body-actions">
          <button type="button"
                  class="marketing-sms-automation-body-actions-item btn btn-outline btn-extra-round"
                  :disabled="hasContent"
                  @click="openTestModal">
            {{$t('message.marketingGenerics.message.testSubmission')}}
          </button>

          <button class="marketing-sms-automation-body-actions-item btn btn-extra-round btn-primary"
                  type="submit">
            {{ actionText }}
          </button>
        </div>
      </app-form>
    </div>

    <marketing-sms-test-modal v-model="showTestModal"
                              :sms-data="smsData"
                              @advance="hideTestModal" />
  </modal>
</template>

<script>
import AppForm from "@components/form/Form.vue";
import TextField from "@components/form/TextField.vue";
import AppTextarea from "@components/form/Textarea.vue";
import MarketingSmsTestModal from "@views/marketing/components/MarketingSmsTestModal";
import Modal from "@/components/generic/Modal";
import EventBus from "@packages/event-bus";

export default {
  components: {
    MarketingSmsTestModal,
    AppForm,
    TextField,
    AppTextarea,
    Modal,
  },

  data() {
    return {
      content: undefined,
      showTestModal: false,
      smsData: undefined,
      internalTitle: undefined,
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    item: {
      type: Object,
    },
  },

  computed: {
    modalTitle() {
      return this.isEdit
        ? this.$t("message.sms.message.editSms")
        : this.$t("message.sms.message.createSms");
    },
    actionText() {
      return this.isEdit
        ? this.$t("message.sms.message.editSms")
        : this.$t("message.sms.message.createSms");
    },
    hasContent() {
      return !this.content;
    },
    isEdit() {
      return !!this.item;
    },
    contentCounter() {
      return /[^a-z0-9 ]/.test(this.content) ? 90 : 160;
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.internalTitle = this.title;
      }
    },
  },

  created() {
    if (this.item) {
      this.content = this.item.content;
      this.smsData = {
        id: this.item.id,
      };
    }
  },

  methods: {
    clearData() {
      this.content = undefined;
      this.showTestModal = false;
      this.smsData = undefined;
      this.internalTitle = undefined;
    },
    emitInput(val) {
      this.$emit("input", val);
    },
    hideModal() {
      this.clearData();
      this.emitInput(false);
    },
    async onSubmit() {
      if (this.isEdit) {
        await this.editMessage();

        this.hideEverything();

        this.$emit("edited");
      } else {
        await this.createMessage();

        this.hideEverything();

        this.$emit("created");
      }
    },
    async createMessage() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        const sms = await this.$api.marketing.sms.message.create({
          content: this.content,
          title: this.internalTitle,
          isAutomationFlow: true,
        });

        this.smsData = {
          id: sms.id,
          content: sms.content,
          title: sms.title,
        };
      } catch (error) {
        // empty error
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    async editMessage() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        const sms = await this.$api.marketing.sms.message.edit({
          smsId: this.item.id,
          data: {
            content: this.content,
            title: this.internalTitle,
            isAutomationFlow: true,
          },
        });

        this.smsData = {
          id: sms.id,
          content: sms.content,
          title: sms.title,
        };
      } catch (error) {
        // empty error
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    hideEverything() {
      this.hideTestModal();
      this.emitInput(false);
    },
    hideTestModal() {
      this.showTestModal = false;
    },
    async openTestModal() {
      if (this.isEdit) {
        await this.editMessage();
      } else {
        await this.createMessage();
      }

      this.showTestModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-sms-automation {
  .marketing-sms-automation-body {
    padding: 20px 40px;

    .marketing-sms-automation-body-title {
      text-align: center;
      font-size: 32px;
      font-weight: 600;
    }

    .marketing-sms-automation-body-text {
      margin-bottom: 20px;
    }

    .marketing-sms-automation-body-actions {
      display: flex;
      justify-content: center;
      gap: 25px;

      .marketing-sms-automation-body-actions-item {
        display: block;
      }
    }
  }
}
</style>
